var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCameraOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M658.103 735.569c0 26.458-20.723 47.99-46.187 47.99h-492.66c-25.464 0-46.187-21.532-46.187-47.99V319.647c0-26.459 20.723-47.99 46.187-47.99h492.66c25.464 0 46.187 21.531 46.187 47.99V735.57z m206.611-420.756l-133.483 86.308v252.926l132.582 85.64c1.423 1.227 9.153 7.307 21.183 7.307 16.026 0 29.058-13.915 29.058-31.025V339.245c0-17.11-13.033-31.024-29.058-31.024-12.03 0-19.759 6.08-20.282 6.592z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraOn);
export default __webpack_public_path__ + "static/media/ic_camera_on.2c9ace7077b058e27672ae68b3a4275b.svg";
export { ForwardRef as ReactComponent };